import type { VoidFunctionComponent } from 'react';

import FilterCard from '../../generic/Filter/FilterCard';
import QualityRequired from '../../generic/Gates/QualityRequired';
import ProjectLabels from '../../projects/dashboardV2/ProjectFilters/ProjectLabels';
import type { AnyFilter } from '../../../../shared/organizationPackages/filters';
import type { MultiSelectFilterOption } from '../../generic/Filter/MultiSelectFilter';

import PackageBlockType from './PackageBlockType';
import PackageInventoryFiltersPackageDepth from './PackageDepth';
import ProjectNameFilters from './ProjectNameFilters';
import PackageInventoryFiltersProjectSource from './ProjectSource';
import PackageInventoryFiltersProjectVisibility from './ProjectVisibility';

type Props = {
  filters: AnyFilter;
  setFilters: (filters: AnyFilter) => void;
};

/**
 * PackageInventoryFiltersProject has filters related to searching
 * by project name, import method, visibility, or project label.
 */
export const PackageInventoryFiltersProject: VoidFunctionComponent<Props> = ({
  filters,
  setFilters,
}) => (
  <FilterCard id="package-inventory-project-filters" title="Project">
    <ProjectNameFilters projectName={filters.projectName ?? ''} setFilters={setFilters} />
    <PackageInventoryFiltersProjectSource sources={filters.sources ?? []} setFilters={setFilters} />
    <PackageInventoryFiltersProjectVisibility visibility={filters.visibility ?? []} setFilters={setFilters} />
    <ProjectLabels
      filterLabels={filters.labels ?? []}
      onChange={(items: MultiSelectFilterOption[]) => setFilters({ labels: items.map(item => item.value) })}
      testId="package-inventory-filters--project-labels"
    />
    <PackageInventoryFiltersPackageDepth depths={filters.depth ?? []} setFilters={setFilters} />
    <QualityRequired>
      <PackageBlockType blockTypes={filters.blockTypes ?? []} setFilters={setFilters} />
    </QualityRequired>
  </FilterCard>
);
